import { URL_ORIGIN } from "@elements/MetaTags/MetaTagsConstants";

export const SHOW_REACTIONS = import.meta.env.VITE_SHOW_REACTIONS === "1";

// Defined cutoff: 2025-08-29 14:30 SGT == 2025-08-29 06:30 UTC
export const REACTIONS_CUTOFF_UTC = "2025-08-29T06:30:00Z";

// VITE_REACTION_EXCLUDE_SECTIONS is a comma-separated list of
// unique section names in env variable to hide reactions for.
// Example: VITE_REACTION_EXCLUDE_SECTIONS=gen-g,youth
export const REACTION_EXCLUDE_SECTIONS: string[] = (
  (import.meta.env.VITE_REACTION_EXCLUDE_SECTIONS as string) || ""
)
  .split(",")
  .map((s) => s.trim().toLowerCase()) // normalize for matching
  .filter(Boolean); // remove empty strings

export const GOOGLE_PREFERRED_SOURCES_LINK = `https://www.google.com/preferences/source?q=${URL_ORIGIN}`;

// Footer news publications
export const FOOTER_NEWS_PUBLICATIONS = [
  {
    title: "The Straits Times",
    url: "https://www.straitstimes.com",
    target: "_blank",
  },
  {
    title: "The Business Times",
    url: "https://www.businesstimes.com.sg",
    target: "_blank",
  },
  {
    title: "Lianhe Zaobao",
    url: "https://www.zaobao.com.sg",
    target: "_blank",
  },
  {
    title: "Berita Harian",
    url: "https://www.beritaharian.sg",
    target: "_blank",
  },
  {
    title: "Tamil Murasu",
    url: "https://www.tamilmurasu.com.sg",
    target: "_blank",
  },
  {
    title: "Stomp",
    url: "https://www.stomp.sg",
    target: "_blank",
  },
];

/**
 * UTM parameters for footer news publication links
 * utm_source=bh
 * utm_medium=sph-publication
 * utm_campaign=backlinks-footer
 */
export const FOOTER_NEWS_PUBLICATIONS_PARAMS = new URLSearchParams({
  utm_source: "bh",
  utm_medium: "sph-publication",
  utm_campaign: "backlinks-footer",
});

/**
 * Articles the web section page renders on load, shared by its loader (`Section.server.ts`, which
 * hands the web exactly this many) and its list (`SectionArticleListNew.tsx`, which shows the
 * "load more" button only when it receives exactly this many and uses the last one's `sort` as the
 * search_after cursor). Change it in one place or the button silently disappears.
 */
export const SECTION_INITIAL_ARTICLE_COUNT = 12;
